import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LeadDetailsState,
  LeadDetails,
  CampaignLeadDetail,
  TimelineLog,
  Attachment,
  Mention,
  Ticket,
} from "../../pages/Communications/utils/types";

const initialState: LeadDetailsState = {
  selectedLeadDetails: null,
  attachments: [],
  tickets: [],
  mentions: [],
  campaignLeadDetails: [],
  timelineLogs: [],
  loading: false,
  error: null,
  leadType: "",
  defaultChannel: "",
};

const leadDetailsSlice = createSlice({
  name: "leadDetails",
  initialState,
  reducers: {
    setLeadDetails: (state, action: PayloadAction<LeadDetails>) => {
      state.selectedLeadDetails = action.payload;
    },
    setAttachments: (state, action: PayloadAction<Attachment[]>) => {
      state.attachments = action.payload;
    },
    updateAttachments: (state, action: PayloadAction<Attachment[]>) => {
      state.attachments = [...state.attachments, ...action.payload];
    },
    setMentions: (state, action: PayloadAction<Mention[]>) => {
      state.mentions = action.payload;
    },
    updateMentions: (state, action: PayloadAction<Mention[]>) => {
      if (state.mentions) {
        state.mentions = [...state.mentions, ...action.payload];
      } else {
        state.mentions = action.payload;
      }
    },
    updateLeadDetails: (state, action: PayloadAction<Partial<LeadDetails>>) => {
      if (state.selectedLeadDetails) {
        state.selectedLeadDetails = {
          ...state.selectedLeadDetails,
          ...action.payload,
        };
      } else {
        state.selectedLeadDetails = action.payload as LeadDetails;
      }
    },
    clearLeadDetails: (state) => {
      state.selectedLeadDetails = null;
      state.timelineLogs = [];
      state.attachments = [];
      state.tickets = [];
      state.campaignLeadDetails = [];
      state.leadType = "";
    },
    setCampaignLeadDetails: (
      state,
      action: PayloadAction<CampaignLeadDetail[]>
    ) => {
      state.campaignLeadDetails = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTimelineLogs: (state, action: PayloadAction<TimelineLog[]>) => {
      state.timelineLogs = action.payload;
    },
    clearTimelineLogs: (state) => {
      state.timelineLogs = [];
    },
    clearCampaignLeadDetails: (state) => {
      state.campaignLeadDetails = [];

      state.error = null;
    },
    setTickets: (state, action: PayloadAction<Ticket[]>) => {
      state.tickets = action.payload;
    },
    updateTickets: (state, action: PayloadAction<Ticket | Ticket[]>) => {
      const newTickets = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      if (state.tickets) {
        state.tickets = [...state.tickets, ...newTickets];
      } else {
        state.tickets = newTickets;
      }
    },
    clearTickets: (state) => {
      state.tickets = [];
    },
    setLeadType: (state, action: PayloadAction<string>) => {
      state.leadType = action.payload;
    },
    setDefaultChannel: (state, action: PayloadAction<string>) => {
      state.defaultChannel = action.payload;
    },
  },
});

export const {
  setLeadDetails,
  updateLeadDetails,
  setAttachments,
  updateAttachments,
  setMentions,
  updateMentions,
  clearLeadDetails,
  setCampaignLeadDetails,
  setLoading,
  setError,
  clearCampaignLeadDetails,
  setTimelineLogs,
  clearTimelineLogs,
  setTickets,
  updateTickets,
  clearTickets,
  setLeadType,
  setDefaultChannel,
} = leadDetailsSlice.actions;

export default leadDetailsSlice;
